import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { AppContext } from "./app-context.service";
import { PosDataService } from "./pos.data.service";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class PosCheckService {
  private interval: number;
  private count: number = 0;
  private delay: number = 0;

  constructor(
    private storage: StorageService,
    private posApi: PosDataService,
    private appContext: AppContext,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  init() {
    this.interval = setInterval(
      (async () => {
        if (this.router.url.split("/").pop() !== "initialization") {
          if (this.router.url.split("/").pop() == "dashboard") {
            if (this.delay < 5) {
              this.delay++;
            } else {
              this.delay = 0;
              await this.checkPos();
            }
          } else {
            await this.checkPos();
          }
        }
      }) as TimerHandler,
      9000
    );
  }

  private async checkPos() {
     const status: boolean = true;
     this.storage.IsPosOnline = status;
    if (
      this.storage.IsPosOnline == true &&
      this.appContext.offlineCounter != 0
    ) {
      this.appContext.offlineCounter = 0;
      this.spinner.hide();
      this.appContext.isConnected = true;
    } else if (false){//this.storage.IsPosOnline == false) {
      this.appContext.offlineCounter++;
    }
    if (this.appContext.offlineCounter != 0) {
      this.spinner.show();
    }
    if (this.appContext.offlineCounter > 2) {
      this.appContext.isConnected = false;
      this.spinner.hide();
    }
  }
}
